import Link, { LinkProps } from 'next/link'
import React from 'react'
import { useTranslate } from '../src/hooks/useTranslate'
import { ImageFragment, ProductFragment } from '../src/model/fragments'
import { DEFAULT_LOCALE, Locale } from '../src/model/locale'
import { GalleryMasonry } from './GalleryMasonry'
import { ProductList, ProductListKind } from './ProductList'
import { Spacer } from './Spacer'

export interface ReferencesProps {
	items: Array<{
		id: string
		name: string
		image?: ImageFragment
		listingImage?: ImageFragment
		products: ProductFragment[]
		linkProps: LinkProps
	}>
	linkToItem: (itemId: string | null) => LinkProps
	initialIndex?: number
}

export const References: React.FunctionComponent<ReferencesProps> = ({
	items,
	linkToItem,
	initialIndex = null,
}) => {
	const translate = useTranslate()
	const [detailIndex, setDetailIndex] = React.useState<null | number>(
		initialIndex ?? 0,
	)

	const [isOpen, setIsOpen] = React.useState(false)

	return (
		<div className="references">

			<Spacer initial={24} />

			<GalleryMasonry
				items={items.filter(it => it.listingImage || it.image).map((item, i) => {

					return {
						...item,
						title:
							<>
								{translate('references-label')}: { item.name }
							</>,
						label: 
							<>


								<a onClick={() => setIsOpen(!isOpen)}>{ isOpen ? (translate('hide-reference-products') + ' ▼') : (translate('show-reference-products') + ' ▲')} </a>
								{isOpen && <div className="references-product-list"><ProductList kind={ProductListKind.Generic} items={item.products} /></div> }
							</>
					};

				})}

				closeCallback={() => setIsOpen(false)}
				changeCallback={(i) => {

					setDetailIndex(i);
				}}
			/>

		</div>
	)
}
